import React from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
  InfoWindow,
} from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY } from "../../globals/const";
import FarmInfoCard from "./FarmInfoCard";

const MapComponent = ({
  farms,
  mapCenter,
  mapZoom,
  selectedFarm,
  hoveredMarker,
  clickedMarker,
  setHoveredMarker,
  setClickedMarker,
  handleMarkerClick,
  extractCoordinates,
}) => {
  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
      <GoogleMap
        mapContainerStyle={{
          width: "100%",
          height: "calc(100vh - 165px)",
        }}
        center={mapCenter}
        zoom={mapZoom}
        options={{
          mapTypeControl: true,
          fullscreenControl: true,
          streetViewControl: false,
          styles: [
            {
              featureType: "poi",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },
          ],
        }}
      >
        <MarkerClusterer>
          {(clusterer) => (
            <>
              {farms.map((farm) => {
                const coords = extractCoordinates(farm.polygon);
                if (!coords) return null;

                return (
                  <Marker
                    key={farm.id}
                    position={coords}
                    onClick={() => handleMarkerClick(farm)}
                    onMouseOver={() => setHoveredMarker(farm)}
                    onMouseOut={() => setHoveredMarker(null)}
                    title={farm.farm_name}
                    animation={
                      selectedFarm?.id === farm.id
                        ? window.google.maps.Animation.BOUNCE
                        : null
                    }
                    clusterer={clusterer}
                    icon={{
                      url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
                      scaledSize: new window.google.maps.Size(36, 36),
                    }}
                  />
                );
              })}
              {(hoveredMarker || clickedMarker) && (
                <InfoWindow
                  position={extractCoordinates(
                    hoveredMarker
                      ? hoveredMarker.polygon
                      : clickedMarker.polygon
                  )}
                  options={{
                    pixelOffset: new window.google.maps.Size(0, -36),
                    disableAutoPan: true,
                    closeBoxURL: "",
                    enableEventPropagation: true,
                  }}
                  onCloseClick={() => {
                    setHoveredMarker(null);
                    setClickedMarker(null);
                  }}
                >
                  <FarmInfoCard farm={hoveredMarker || clickedMarker} />
                </InfoWindow>
              )}
            </>
          )}
        </MarkerClusterer>
      </GoogleMap>
    </LoadScript>
  );
};

export default MapComponent;
